export const URL_PARAMETER_CL: string = 'cl';

export const URL_PARAMETER_UTM_CAMPAIGN: string = 'utm_campaign';
export const URL_PARAMETER_UTM_MEDIUM: string = 'utm_medium';
export const URL_PARAMETER_UTM_SOURCE: string = 'utm_source';
